import React from 'react';
import Container from 'legacy/common/components/layout/Container';

const OfferDetailsSkeleton: React.FC = () => (
  <Container>
    <div className="animate-pulse pt-[90px] md:pt-[180px] -mt-[90px] pb-20 md:w-[630px] md:mx-auto">
      <div className="h-8 bg-gray-200 rounded w-1/6 mb-8" />
      <div className="flex flex-col space-y-2 w-full">
        <div className="h-8 bg-gray-200 rounded w-1/6" />
        <div className="h-12 bg-gray-200 rounded w-3/6 " />
      </div>

      <div className="flex flex-col space-y-2 w-full mt-8">
        <div className="h-8 bg-gray-200 rounded w-1/6" />
        <div className="h-12 bg-gray-200 rounded w-3/6 " />
      </div>

      <div className="h-12 bg-gray-200 rounded w-5/6 mt-8" />

      <div className="flex flex-row">
        <div className="flex flex-col space-y-2 w-full mt-8">
          <div className="h-8 bg-gray-200 rounded w-4/6" />
          <div className="h-6 bg-gray-200 rounded w-2/6 " />
        </div>

        <div className="flex flex-col space-y-2 w-full mt-8">
          <div className="h-8 bg-gray-200 rounded w-4/6" />
          <div className="h-6 bg-gray-200 rounded w-2/6 " />
        </div>
      </div>

      <div className="flex flex-row">
        <div className="flex flex-col space-y-2 w-full mt-8">
          <div className="h-8 bg-gray-200 rounded w-4/6" />
          <div className="h-6 bg-gray-200 rounded w-2/6 " />
        </div>

        <div className="flex flex-col space-y-2 w-full mt-8">
          <div className="h-8 bg-gray-200 rounded w-4/6" />
          <div className="h-6 bg-gray-200 rounded w-2/6 " />
        </div>
      </div>
    </div>
  </Container>
);

export default OfferDetailsSkeleton;
